import { ReactComponent as SvgMark } from '../../../../images/svg/mark.svg'
import styles from './styles.module.css'

const FEATURES = [
  'Setup secure third-party access in seconds.',
  'Monitor, terminate, and record live sessions.',
  'Instant just-in-time access.',
  'Zero Trust Access without VPN.'
]

const Profile = () => {
  return (
    <ul className={styles.stats}>
      {FEATURES.map(item => (
        <li key={item}>
          <SvgMark />
          {item}
        </li>
      ))}
    </ul>
  )
}

export default Profile
